export function getContact(state) {
  return state.currentContactData;
}
